(function () {
    'use strict';

    angular
        .module('app')
        .controller('coPrototypeSearchController', function coPrototypeSearchController($scope, $window, $cookies, $location, $rootScope, $filter, $timeout, $state, $stateParams, LinePlanService, PrototypeService, BrandService, SeasonService, UserService, CarryoverData, CarryoverService, toaster, cfpLoadingBar) {
            var model = this;
            $scope.permissionDenied = function () {
                $state.go('permissionDenied');
            }

            $scope.goToUserPage = function (data) {
                $state.go(data.pageName, data.params);
            }

            $scope.loaderClosed = function () {
                cfpLoadingBar.complete();
            }

            $scope.loaderStart = function () {
                cfpLoadingBar.start();
            }
            angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
                if (userPermissionRow[0] == 14) {
                    if (userPermissionRow[1] == 2) {
                        model.CarryoverEdit = true;
                    }
                }
            });

            if (!model.CarryoverEdit) {
                $state.go('permissionDenied');
            }

            model.isDisabled = true;
            model.brands = "";
            model.patternId = 0;
            model.radioValue = "";
            model.patternsCount = -1;
            model.prototypes = [];
            model.selectedProtos = [];
            model.linePlans = "";
            model.test = [];
            model.pageNumber = 1;
            model.pageSize = 50;

            $scope.windowGridHeight = function () {
                if (window.outerHeight >= 768) {
                    return window.innerHeight - 502;
                } else {
                    var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                    return (size * gridOptions.rowHeight) + 46;
                }
            };

            function getBrands() {
                //BrandService.getBrandsByUser().then(function (data) {
                //    model.brands = data;
                //    cfpLoadingBar.complete();
                //}, function (error, status) {
                //});
            }

            function resetFactoryData() {
                CarryoverData.reset();
            }

            $scope.getSeasonsByBrand = function (brandId, a) {
                SeasonService.getSeasonsByBrand(brandId.BrandId).then(function (data) {
                    model[a] = data;
                });
            };

            function getUsersByBrand(brandId) {
                UserService.getUsersByBrand(brandId).then(function (data) {
                    model.users = data;
                }, function (error, status) {
                    //console.log(error);
                });
            }

            getBrands();
            if (CarryoverData.data.length > 0) {
                resetFactoryData();
            }
            model.loadData = function (brand) {
                model.prototypes = [];

                //reset data to 0
                CarryoverData.reset();

                getUsersByBrand(brand.BrandId);
            };

            function resetValues() {
                $scope.carryoverStartForm.toseason.$setUntouched();
                $scope.carryoverStartForm.toLineplan.$setUntouched();
                $scope.carryoverStartForm.$setPristine(true);
            }

            model.loadCarryoverPage = function (pageNumber, pageSize) {
                model.pageNumber = pageNumber;
                model.pageSize = pageSize;
                model.get(model.carryoverseason.selectedSeason.SeasonId,
                    model.newPrototypeSeason.selectedBrand.BrandId);
            };

            model.get = function (seasonId, brandId, reset) {
                if (reset) {
                    CarryoverData.reset();
                    model.colorwaysSelected = 0;
                }
                var searchObject = {
                    SeasonId: seasonId,
                    BrandId: brandId,
                    PageNumber: model.pageNumber,
                    PageSize: model.pageSize,
                    CarryoverData: model.filterText ? model.filterText : true,
                    IncludePatternLevel: true
                };
                model.prototypesLoading = true;
                model.prototypes = [];
                PrototypeService.searchPrototypes(searchObject)
                    .then(function (response) {
                        model.prototypesLoading = false;
                        if (response.results) {

                            model.prototypes = response;
                            //build pagerdata without results
                            $scope.pagerData = {
                                CurrentPageNumber: model.prototypes.currentPage,
                                PageSize: model.prototypes.pageSize,
                                TotalPageCount: model.prototypes.totalPages,
                                TotalRecords: model.prototypes.totalRecords,
                                firstRecord: model.prototypes.firstRecord,
                                lastRecord: model.prototypes.lastRecord
                            };

                            //rebuild checks after page load
                            var coData = CarryoverData.data;
                            if (coData.length) {
                                angular.forEach(response.results,
                                    function (k) {
                                        var p = k.PrototypeSeasonalId;
                                        var item = k;
                                        angular.forEach(coData,
                                            function (k) {
                                                if (p == k.PrototypeSeasonalId) {
                                                    item.isChecked = true;
                                                }
                                            });
                                    });
                            }
                        }
                    },
                        function (error, status) {
                            model.prototypes = null;
                            toaster.pop({
                                type: 'error',
                                title: 'Error!',
                                body: 'There was an error getting Colorways for Carryover. Please contact system administrator',
                                timeout: 5000
                            });
                            $scope.carryoverStartForm.$setPristine();
                            $scope.carryoverStartForm.$setUntouched();
                        });
            };

            //   get list of line plans to select from
            model.getLinePlansByBrandSeason = function (brandId, seasonId) {
                LinePlanService.getLinePlansByBrandSeason(brandId, seasonId, 0).then(function (response) {
                    if (response) {
                        model.linePlans = response;
                    } else {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'No Line Plan Found',
                            timeout: 5000
                        });
                    }
                });
            };

            model.addPrototypeCO = function (prototype) {
                var dataIndex = CarryoverData.data.indexOf(prototype);
                if (dataIndex == -1) {
                    CarryoverData.update(prototype);
                } else {
                    CarryoverData.remove(dataIndex);
                }
                //count the amount of carryovers selected to be able to continue through
                model.colorwaysSelected = CarryoverData.data.length;
            };

            model.carryoverReview = function () {
                if (CarryoverData.data.length > 0) {
                    $state.go("carryoverFinal");
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'Please Select at least one Prototype',
                        timeout: 5000
                    });
                }
            };

            //Upload functions
            $scope.documentInterface = {};
            $scope.massForecastMetaData = {};

            $scope.$on('$dropletReady', function whenDropletReady() {
                $scope.documentInterface.allowedExtensions(['.xlsx', '.xls']);
                $scope.documentInterface.defineHTTPSuccess([/2.{2}/]);
                $scope.documentInterface.useArray(true);
            });

            $scope.selectDoc = function (e) {
                uploadDoc(e.files[0], 'browse');
            }

            $scope.addDoc = function (file) {
                uploadDoc(file.file, 'dragdrop');
            }

            function clearFileSelect() {
                $scope.documentInterface = {};
                document.getElementById('file').value = null;
            }

            function uploadDoc(file, source) {
                $scope.file = file;

                var ext = $scope.file.name.substr($scope.file.name.lastIndexOf('.') + 1)
                if (ext != "xls" && ext != "xlsx") {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: "Please upload an Excel file (.xls or .xlsx)",
                        timeout: 5000
                    });
                    clearFileSelect();

                    return;
                }

                CarryoverService.uploadMassCarryoverDocument($scope.file, model.selectedtoSeason.SeasonId, model.toLinePlan.LinePlanId)
                    .then(function (response) {
                        toaster.pop({
                            type: 'success',
                            title: 'File uploaded!',
                            body: 'You will be notified by email when processing is complete.',
                            timeout: 5000
                        });
                        clearFileSelect();
                        //   $state.go('carryover');
                    }, function (error, status) {
                        toaster.pop({
                            type: 'error',
                            title: 'File Upload Error!',
                            body: 'There was an error while uploading your file.',
                            timeout: 3000
                        });
                        clearFileSelect();
                    });
            }

            //cfpLoadingBar.complete();

        });
})();
